import React from 'react'
import { get } from 'lodash'
import { MenuItem, Position } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import { ILeaseEventUnit } from '@api'

interface IUnitItem {
  label: string
  value: ILeaseEventUnit
}

const items: IUnitItem[] = [
  { label: '$', value: '$' },
  { label: '$/sqft', value: '$/sqft' },
  { label: 'Sqft', value: 'Sqft' },
  { label: 'Other', value: 'Other' },
]

const EventTypeSelect = Select2<IUnitItem>

interface IProps {
  buttonProps?: IUIButtonProps
  placeholder?: string
  value: ILeaseEventUnit | string
  onChange: (type: IUnitItem) => void
}

export default function LeaseEventTypeSelect({
  onChange,
  placeholder,
  value,
  buttonProps,
}: IProps) {
  return (
    <EventTypeSelect
      popoverProps={{
        position: Position.BOTTOM,
        minimal: true,
      }}
      filterable={false}
      items={items}
      itemRenderer={(unit, { handleClick }) => (
        <MenuItem
          key={unit.value}
          active={value ? unit.value === value : false}
          onClick={handleClick}
          text={unit.label}
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        {...buttonProps}
        rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
        text={value ? value : placeholder || 'Select'}
      />
    </EventTypeSelect>
  )
}
